import React, { useState } from 'react';

import classNames from 'classnames';

import styles from './FileDrop.module.css';
import { useOrionUID } from '../../helpers/orionUID';
import { useLang } from '../../helpers/useLang';
import { Icon } from '../icon/Icon';

export type FileDropProps = {
  showButton?: boolean;
  stacked?: boolean;
  onChange: (files: File[]) => void;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>;

export const FileDrop = ({
  showButton = true,
  stacked = true,
  onChange,
  className,
  ...inputProps
}: FileDropProps) => {
  const lang = useLang();
  const orionUID = useOrionUID();
  const [draggedOver, setDraggedOver] = useState(false);

  const handleDrag = (
    ev: React.DragEvent<HTMLDivElement>,
    draggedOver: boolean,
  ) => {
    ev.preventDefault();
    setDraggedOver(draggedOver);
  };

  const handleDrop = (ev: React.DragEvent<HTMLDivElement>) => {
    const data = ev.dataTransfer;
    const files = data.files;

    onChange(Array.from(files));
  };

  return (
    <div
      className={classNames(
        styles.fileDrop,
        {
          [styles.highlight]: draggedOver,
          [styles.stacked]: stacked,
        },
        className,
      )}
      onDragEnter={(ev) => handleDrag(ev, true)}
      onDragOver={(ev) => handleDrag(ev, true)}
      onDragLeave={(ev) => handleDrag(ev, false)}
      onDrop={(ev) => {
        handleDrag(ev, false);
        handleDrop(ev);
      }}
    >
      {showButton && (
        <>
          <input
            className={styles.fileInput}
            id={orionUID}
            type="file"
            multiple
            onChange={(ev) =>
              ev.target.files && onChange(Array.from(ev.target.files))
            }
            {...inputProps}
          />
          <label
            className={styles.uploadLabel}
            htmlFor={inputProps.id || orionUID}
          >
            <Icon icon="upload" />
            <span>{lang === 'de' ? 'Laden' : 'Upload'}</span>
          </label>
        </>
      )}
      {lang === 'de' ? (
        <span>Sie hier weitere Unterlagen hoch</span>
      ) : (
        <span>{showButton && 'or'} drag & drop files here</span>
      )}
    </div>
  );
};
